/**
 * 优势描述
 */

import * as React from 'react'
import { Button } from 'antd'
import { IconSvg } from '@/components'
import styles from './index.module.less'

export default function Index({ title, contents, handleClick, sortNum, translateTxt }: any) {
  return (
    <div className={styles.desc}>
      <div className={styles.title}>{title}</div>
      <ul className={styles.list}>
        {contents.map((item: string) => (
          <li key={item} className={styles['desc-item']}>
            <div className={styles.icon}>
              <span className={styles.circle} />
            </div>
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <div>
        <Button
          type="primary"
          style={{ marginTop: 32, cursor: 'pointer' }}
          onClick={handleClick}
          className={`FirstScreenButton${sortNum}`} // 曝光类名标识
        >
          {translateTxt('dashboard:t4')}{' '}
          <IconSvg style={{ marginLeft: 8, fontSize: 12 }} type="icon-xiangyou" />
        </Button>
      </div>
    </div>
  )
}
